import { Col, Form, Input, Row, Select, Button } from 'antd'
import React, { useEffect } from 'react'
import { Grid } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import flags from "react-phone-number-input/flags";
import "react-phone-number-input/style.css";

import makeRequest from '../../../libs/request'
import {
  showErrorMessage,
  showSuccessMessageIcon,
} from '../../../actions/notification'

const AddOwnerComponent = ({ values, handleCancel, handleSave, companyId, open }) => {
  const [form] = Form.useForm()
  const handleSubmit = async (value) => {
    let payload = {
      ...values,
      name: value?.name ?? undefined,
      email: value?.email ?? undefined,
      mobile_number:
        value?.mobile_number !== '' ? value?.mobile_number : undefined,
      type: value?.type ?? undefined,
      company: values?.company ?? companyId,
      type: 'ICPA',
    }
    if (payload?._id) {
      await makeRequest('put', `icpa/owners/update/${payload?._id}`, payload)
        .then(({ data }) => {
          if (data.signal) {
            form.setFieldsValue({
              name: '',
              email: '',
              mobile_number: '',
              type: 'co-owner',
              company: companyId,
            })
          } else {
            return showErrorMessage('Update owners successfully.')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    } else {
      await makeRequest('post', `icpa/owners/create`, payload)
        .then(({ data }) => {
          if (data.signal) {
            form.setFieldsValue({
              name: '',
              email: '',
              mobile_number: '',
              type: 'co-owner',
              company: companyId,
            })
          } else {
            return showErrorMessage('Add Owners successfully.')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
    await handleSave(payload)
    return
  }

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue({
      name: values?.name ?? '',
      email: values?.email ?? '',
      mobile_number: values?.mobile_number ?? '',
      type: values?.type ?? 'co-owner',
      company: values?.company ?? companyId,
    })
  }, [values, open])

  return (
    <Form
      form={form}
      name='login'
      autoComplete='off'
      layout='vertical'
      onFinish={handleSubmit}
      requiredMark={false}
      className='form-item-customer'
      initialValues={{}}
      validateTrigger=''
    >
      <Row gutter={24} className='mt-16'>
        <Col className='gutter-row' span={24}>
          <Form.Item
            label='Owner Name'
            name='name'
            rules={[
              {
                required: true,
                message: 'Owner Name is required!',
                whitespace: true,
              },
            ]}
            className='required-value'
          >
            <Input placeholder='Enter Owner Name' />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24} className='mt-8'>
        <Col span={24}>
          <Form.Item
            label='Email for Notification'
            name='email'
            rules={[
              {
                required: true,
                message: 'Email for notification is required!',
              },
              {
                required: false,
                pattern: new RegExp(/^[a-zA-Z0-9._-]+@[a-z]+\.[a-z]{2,6}$/),
                message: 'Email for Notification invalid!',
              },
            ]}
            className='required-value'
          >
            <Input placeholder='Enter email' disabled={!!values?._id} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24} className='mt-8'>
        <Col span={24}>
          <Form.Item
            label='Mobile Number'
            name='mobile_number'
            rules={[
              {
                validator: (_, value) => {
                  if (!value || value.trim() === '') {
                    return Promise.resolve(); // Không bắt buộc
                  }
                  const isValid = isValidPhoneNumber(value);
                  return isValid
                    ? Promise.resolve()
                    : Promise.reject('Mobile number is invalid!');
                },
              },
            ]}
          >
            <PhoneInput
              international
              countryCallingCodeEditable={false}
              className={"form-control phone-number-custom"}
              flags={flags}
              placeholder="Enter mobile number"
              defaultCountry="SG"
              onChange={(value) => {
                form.setFieldsValue({ mobile_number: value ?? '' })
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24} className='mt-8'>
        <Col span={24}>
          <Form.Item
            label='Ownership'
            name='type'
            rules={[{ required: true, message: 'Ownership is required!' }]}
            className='required-value'
          >
            <Select
              placeholder='Select owner'
              optionFilterProp='label'
              options={[
                { label: 'Co-Owner', value: 'co-owner' },
                { label: 'Main Owner', value: 'main-owner' },
                { label: "Management Representative", value: "management_representative" },
              ]}
              disabled={!!values?._id}
            />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item className='row-center mt-32'>
        <Grid container spacing={1}>
          <Grid container item xs={6}>
            <Button
              variant='secondary'
              type='button'
              className='lms-secondary-btn'
              style={{
                width: '100%',
                height: '40px',
                marginRight: 5,
              }}
              onClick={handleCancel}
            >
              <FormattedMessage id='PAGE.BUTTON.SPAN.CANCEL' />
            </Button>
          </Grid>
          <Grid container item xs={6}>
            <Button
              variant='primary'
              type='submit'
              htmlType='submit'
              className='lms-btn'
              style={{
                width: '100%',
                height: '40px',
              }}
            >
              Confirm
            </Button>
          </Grid>
        </Grid>
      </Form.Item>
    </Form>
  )
}

export default AddOwnerComponent
